import i18n from 'i18next';

const AI_CIO_NS = 'ai-cio';

/**
 * The UI's language as a BCP-47 code (what i18next resolved), sent to the
 * orchestrator so it answers, and words its status line, in that language.
 */
export function uiLanguage(): string | undefined {
  const lang = i18n.resolvedLanguage ?? i18n.language;
  return lang && lang !== 'cimode' ? lang : undefined;
}

export function tr(
  key: string,
  defaultValue: string,
  values: Record<string, string | number> = {},
): string {
  const value: unknown = i18n.t(key, defaultValue, { ns: AI_CIO_NS, ...values });
  const text = typeof value === 'string' ? value : defaultValue;
  return text.replace(/\{\{(\w+)\}\}/g, (match, name: string) =>
    name in values ? String(values[name]) : match,
  );
}
